var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',{staticClass:"align-center justify-center primary white--text mb-4"},[_vm._v("Historique")]),_c('v-card-text',[(_vm.loading)?_c('v-skeleton-loader',{attrs:{"type":"table-tbody"}}):_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.contractValidityHistory,"items-per-page":5}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }